function Spacer(props) {
        return (
            <div className='mx-auto' style={{height: '1px', width: '50%', backgroundColor: '#D7D7D7'}}>
            </div>
            )
               
}

export default Spacer